import { Cake, Droplet, Droplets, FlaskConical, Heart, Leaf, Pipette, Sparkles, SprayCan, Wind } from "lucide-react";
import type { Collection } from "../types/product";
import { images } from "./product";

export const collections: Collection[] = [
  {
    title: "Burri, creme e sieri",
    count: 260,
    image: images.butters,
    lead: "Burri corpo, creme e sieri fatti in casa non devono essere complicati",
    description: ": bastano pochi ingredienti semplici per iniziare.",
    items: [
      { count: 95, label: "ricette di burro corpo", icon: Cake },
      { count: 65, label: "ricette di oli corpo e viso", icon: Droplet },
      { count: 50, label: "ricette di lozioni e creme", icon: FlaskConical },
      { count: 50, label: "ricette di sieri viso", icon: Pipette },
    ],
  },
  {
    title: "Saponi, scrub e balsami",
    count: 155,
    image: images.soaps,
    lead: "Saponi, scrub e balsami sono tra i prodotti più appaganti da fare",
    description: ": ingredienti semplici, ricette pratiche e qualcosa che userai con piacere.",
    items: [
      { count: 75, label: "ricette di sapone montato", icon: Droplets },
      { count: 50, label: "ricette di scrub e peeling", icon: Sparkles },
      { count: 30, label: "ricette di balsami alle erbe", icon: Leaf },
    ],
  },
  {
    title: "Labbra, brume e deodoranti",
    count: 187,
    image: images.lips,
    lead: "Gli essenziali di ogni giorno che completano la tua routine",
    description: ": labbra, brume e deodoranti, tutto fatto da te.",
    items: [
      { count: 95, label: "ricette di labbra (oli e balsami)", icon: Heart },
      { count: 65, label: "ricette di brume e tonici", icon: SprayCan },
      { count: 27, label: "ricette di deodoranti naturali", icon: Wind },
    ],
  },
];
